import header from "./modules/header";
import dropdown from "./modules/dropdown";
import video from "./modules/video";
import modal from "./modules/modal";
import inputMask from "./modules/input-mask";
import validation from "./modules/validation";
import gallery from "./modules/gallery";
import Toastify from "toastify-js";
import goodsHeaderMove from './modules/goods-header-move'

window.toast = (props) => {
    return Toastify(props).showToast();
}

header();
dropdown();
video();
modal();
inputMask();
validation();
gallery();